import React, {FC, ReactNode} from "react"
import {isString} from "lodash"

import {InjectIntl} from "@irati/utils/lang"
import {injectIntl} from "@irati/utils/lang/injectIntl"
import getMessage from "@irati/utils/lang/helpers/getMessage"

export interface TextProps {
  children: ReactNode | string
  values?: any
}
const Text: FC<TextProps> = injectIntl((props: TextProps & InjectIntl) => {
  const {formatMessage, values, children} = props
  const newChildren = isString(children) ? getMessage(formatMessage, children, values) : children

  return <div>{newChildren}</div>
})

export default injectIntl(Text)
